<template>
    
    <v-container fluid>

        <v-flex>
            <v-layout row>
                <p>Object fields</p>
                <v-spacer></v-spacer>
                <v-icon color="success" @click="addField()">mdi-plus</v-icon>   
            </v-layout>
        </v-flex>           

        <v-container class="pa-1" v-for="(field, index) in organisations.type.fields" :key="index">
            <v-layout row align-center="">
                <v-flex xs3>
                  <v-text-field clearable @change="app.settings.change = true" label="Description" v-model="organisations.type.fields[index].name" >{{field.name}}</v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field clearable @change="app.settings.change = true" label="Field" v-model="organisations.type.fields[index].field">{{field.field}}</v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-autocomplete clearable  @change="app.settings.change = true" :items="field_types" label="Type" v-model="organisations.type.fields[index].type" >{{field.type}}</v-autocomplete>
                </v-flex>
                <v-flex xs3 class="text-right">               
                    <v-icon color="error" @click="deleteField(index)">mdi-minus</v-icon>    
                    <v-icon :disabled="index == 0" color="success" @click="downField(index - 1, index)">mdi-chevron-up</v-icon>    
                    <v-icon :disabled="index == organisations.type.fields.length -1" color="success" @click="upField(index + 1, index)">mdi-chevron-down</v-icon>                                                         
                </v-flex> 
            </v-layout>
        </v-container>                        
    </v-container>   

</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    field_types: [
      "text",
      "textarea",
      "phone",
      "email",
      "switch",
      "yes-no",
      "checkbox",
      "estate",
      "address",
      "date"
    ]
  }),
  computed: {
    ...mapState(["organisations", "app"])
  },
  methods: {
    addField() {
      var newField = { name: "", field: "", type: "" };
      this.$store.state.organisations.type.fields.push(newField);
      this.app.settings.change = true;
    },
    deleteField(index) {
      this.$store.state.organisations.type.fields.splice(index, 1);
      this.app.settings.change = true;
    },
    downField(from, to) {
      let data = this.$store.state.organisations.type.fields;
      let cutOut = data[from];
      data.splice(from, 1);
      data.splice(to, 0, cutOut);
      this.app.settings.change = true;
    },
    upField(from, to) {
      let data = this.$store.state.organisations.type.fields;
      let cutOut = data[from];
      data.splice(from, 1);
      data.splice(to, 0, cutOut);
      this.app.settings.change = true;
    }
  }
};
</script>

